export const ACTION_TYPES_NEW = {
  GET_NEWS_DETAIL: "GET_NEWS_DETAIL",
  GET_NEWS_DETAIL_SUCCESS: Symbol("GET_NEWS_DETAIL_SUCCESS"),
  GET_NEWS_DETAIL_ERROR: Symbol("GET_NEWS_DETAIL_ERROR"),
  CLEAR_NOTIFY: Symbol("CLEAR_NOTIFY")
};
